var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.status != null)?_c('v-chip',{staticClass:"font-weight-bold elevation-1",attrs:{"small":"","color":_vm.colorAndTranslation.color,"text-color":_vm.getFontColor(_vm.colorAndTranslation.color)}},[_vm._v(" "+_vm._s(_vm.colorAndTranslation.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }